import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import "./Footer.scss";
import { FormattedMessage } from "react-intl";
import { getIP, increaseView, getView } from "../../../services/userService";
import { v4 as uuidv4 } from "uuid";
import { path } from "../../../utils/constant";
//Thư viện gọi trả về device_type như mobile, laptap hay table cũng như browser/os
import UAParser from "ua-parser-js";
import GooglePlay from "../../../assets/images/google-play.png";
import AppStore from "../../../assets/images/app-store.png";
import favicon from "../../../assets/images/favicon.png";
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      views: 0,
      ip: null,
      session_id: null,
    };
  }

  async componentDidMount() {
    await this.fetchTotalViews();
    this.handleVisitorTracking();
  }

  handleVisitorTracking = async () => {
    const ipData = await this.getClientIP();
    if (!ipData || !ipData.ip) return;

    const ip = ipData.ip;
    const currentTime = Date.now();
    const stored = JSON.parse(localStorage.getItem("visitor_info"));

    if (!stored || stored.ip !== ip) {
      // IP mới → gửi view
      const session_id = this.generateSessionId(ip);
      this.saveVisitorInfo(ip, session_id, currentTime);
      this.sendViewToServer(ip, session_id);
    } else {
      // IP cũ → kiểm tra thời gian
      const lastViewTime = stored.last_view_time || 0;
      const diffMinutes = (currentTime - lastViewTime) / (1000 * 60);

      if (diffMinutes >= 5) {
        this.sendViewToServer(stored.ip, stored.session_id);
        this.updateLastViewTime(currentTime);
      }
    }
  };

  getClientIP = async () => {
    try {
      //return await axios.get("api/get-ip");
      const res = await getIP();
      return res;
    } catch (error) {
      console.error("❌ Lỗi khi lấy IP:", error);
      return null;
    }
  };
  generateSessionId = (ip) => {
    const uniquePart = uuidv4();
    const encoded = btoa(`${ip}-${uniquePart}`);
    return encoded;
  };
  saveVisitorInfo = (ip, session_id, timestamp) => {
    const data = { ip, session_id, last_view_time: timestamp };
    localStorage.setItem("visitor_info", JSON.stringify(data));
  };
  //Đến đoạn này lưu user vào info rồi
  updateLastViewTime = (timestamp) => {
    const data = JSON.parse(localStorage.getItem("visitor_info"));
    if (data) {
      data.last_view_time = timestamp;
      localStorage.setItem("visitor_info", JSON.stringify(data));
    }
  };

  sendViewToServer = async (ip, session_id) => {
    const parser = new UAParser();
    const ua = parser.getResult();

    const referer = document.referrer || "Direct";
    const path = window.location.pathname;
    const currentTime = Date.now();
    const duration = this.pageLoadTime
      ? Math.floor((currentTime - this.pageLoadTime) / 1000)
      : 0;

    const payload = {
      ip,
      session_id,
      path,
      referer,
      device_type: ua.device.type || "desktop",
      browser: ua.browser.name || null,
      os: ua.os.name || null,
      status_code: 200,
      duration,
      user_agent: navigator.userAgent,
    };

    try {
      await increaseView(payload);
    } catch (err) {
      console.error("❌ Lỗi khi gửi view:", err);
    }
  };

  fetchTotalViews = async () => {
    try {
      const res = await getView(); // Gọi API lấy tổng lượt view
      if (res && res.status === 200) {
        this.setState({ views: res.total_views });
      } else {
        console.warn("Không lấy được tổng view hợp lệ:", res);
      }
    } catch (error) {
      console.error("Lỗi khi lấy tổng view:", error);
    }
  };
  componentDidUpdate(prevProps, prevState, snapshot) {}
  render() {
    const { views } = this.state;
    const formattedViews =
      views < 1000
        ? `${views} lượt xem`
        : `${(views / 1000).toFixed(1)}K lượt xem`;
    return (
      <>
        <footer className="footer-wrap v2">
          <div className="footer-top">
            <div className="container">
              <div className="row">
                {/* <div className="col-xl-8 col-lg-8 col-md-6 img">
                  <img
                    src="/static/picture/patent.png"
                    className="patent-img"
                    alt="none"
                  />
                </div> */}
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <div className="footer-widget">
                    <div className="footer-widget-title">
                      <h5>Chính sách và điều khoản dịch vụ</h5>
                    </div>
                    <div className="comp-text note-text">
                      <p>Áp dụng cho tất cả khách hàng tại Việt Nam</p>
                      <p>
                        Công ty TNHH Hải Phước - Nhà phân phối chính thức thiết
                        bị phân tích cơ thể Anovator A5
                      </p>
                    </div>
                    <div className="comp-address-wrap">
                      <div className="comp-policy-list">
                        <ul>
                          <li>
                            <img
                              src={favicon}
                              alt="Privacy Policy Icon"
                              className="policy-icon"
                            />
                            <Link to={path.PRIVACYPOLICY}>
                              <FormattedMessage id="footer.a1" />
                            </Link>
                          </li>
                          <li>
                            <img
                              src={favicon}
                              alt="Privacy Policy Icon"
                              className="policy-icon"
                            />
                            <Link to={path.REFUNDPOLICY}>
                              <FormattedMessage id="footer.a2" />
                            </Link>
                          </li>
                          <li>
                            <img
                              src={favicon}
                              alt="Privacy Policy Icon"
                              className="policy-icon"
                            />
                            <Link to={path.SHIPPINGPOLICY}>
                              <FormattedMessage id="footer.a3" />
                            </Link>
                          </li>
                          <li>
                            <img
                              src={favicon}
                              alt="Privacy Policy Icon"
                              className="policy-icon"
                            />
                            <Link to={path.TERM}>
                              <FormattedMessage id="footer.a4" />
                            </Link>
                          </li>
                          <li>
                            <img
                              src={favicon}
                              alt="Privacy Policy Icon"
                              className="policy-icon"
                            />
                            <Link to="/product-warranty">
                              <FormattedMessage id="footer.a18" />
                            </Link>
                          </li>
                          <li>
                            <img
                              src={favicon}
                              alt="Privacy Policy Icon"
                              className="policy-icon"
                            />
                            <Link to="/faq">FAQ</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <div className="footer-widget">
                    <div className="footer-widget-title">
                      <h5>
                        <FormattedMessage id="footer.a5" />
                      </h5>
                    </div>
                    <div className="comp-text">
                      <p>
                        <FormattedMessage id="footer.a6" />
                      </p>
                    </div>
                    <div className="comp-address-wrap">
                      <div className="com-address-item">
                        <div className="com-address-icon">
                          <i className="las la-envelope" />
                        </div>
                        <div className="comp-address-info">
                          <p>Email:</p>
                          <a href="mailto:sales@anovator.com">
                            sales@anovator.vn
                          </a>
                        </div>
                      </div>
                      <div className="com-address-item">
                        <div className="com-address-icon">
                          <i className="las la-phone" />
                        </div>
                        <div className="comp-address-info">
                          <p>Hotline / Zalo OA:</p>
                          <p>
                            <a href="tel:0359515131">0359.515.131</a>
                            &nbsp;(Phước)
                          </p>
                        </div>
                      </div>

                      {/* //Biểu tượng nằm ở đây */}
                      {/* <div className="com-address-item">
                        <div className="left-content col-md-6">
                          <a
                            href="https://apps.apple.com/app/anovator/id6479684072"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={GooglePlay} alt="Tải trên Google Play" />
                          </a>
                        </div>

                        <div className="right-content col-md-6">
                          <a
                            href="https://apps.apple.com/vn/app/anovator/id6445943952"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={AppStore} alt="Tải trên App Store" />
                          </a>
                        </div>
                      </div> */}
                      <div className=" row">
                        <div className="col-md-4 col-4 col-sm-4 col-item-download">
                          <a
                            href="https://apps.apple.com/app/anovator/id6479684072"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={GooglePlay} alt="Tải trên Google Play" />
                          </a>
                        </div>

                        <div className="col-md-4 col-4 col-sm-4 col-item-download">
                          <a
                            href="https://apps.apple.com/us/app/anovator/id6479684072"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={AppStore} alt="Tải trên App Store" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="social-profile">
                      <ul>
                        <li>
                          <a
                            href="https://www.facebook.com/share/1FAC25vVnc/?mibextid=wwXIfr"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/static/svg/facebook.svg"
                              alt="facebook"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.tiktok.com/@anovator.vietnam"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/static/svg/icons8-tiktok.svg"
                              alt="tiktok"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/anovator_vn"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/static/svg/instagram.svg"
                              alt="instagram"
                              className="icon-instagram"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.threads.net/@anovator_vn"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/static/svg/threads-white.svg"
                              alt="threads"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://pin.it/6qDxT1NaT"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/static/svg/pinterest.svg"
                              alt="pinterest"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="footer-widget">
                    <div className="footer-widget-title">
                      <h5>
                        <FormattedMessage id="footer.a7" />
                      </h5>
                    </div>
                    <div className="comp-location-wrap row">
                      <div className="col-lg-3 grid-item">
                        <div className="comp-location">
                          <div className="loc-icon">
                            <i className="las la-map-marker-alt" />
                          </div>
                          <h6>
                            <FormattedMessage id="footer.a8" />
                          </h6>
                          <span>
                            <FormattedMessage id="footer.a10" />
                          </span>
                          <p>
                            SĐT/Zalo: <a href="tel:0962975302">096.297.5302</a>
                            &nbsp;(Bảo)
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 grid-item">
                        <div className="comp-location">
                          <div className="loc-icon">
                            <i className="las la-map-marker-alt" />
                          </div>
                          <h6>
                            <FormattedMessage id="footer.a9" />
                          </h6>
                          <span>
                            <FormattedMessage id="footer.a11" />
                          </span>
                          <p>
                            SĐT/Zalo: <a href="tel:0902408889">0902.408.889</a>
                            &nbsp;(Hoa)
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 grid-item">
                        <div className="comp-location">
                          <div className="loc-icon">
                            <i className="las la-map-marker-alt" />
                          </div>
                          <h6>
                            <FormattedMessage id="footer.a9_1" />
                          </h6>
                          <span>
                            <FormattedMessage id="footer.a12" />
                          </span>
                          <p>
                            SĐT/Zalo: <a href="tel:0971529771">0971.529.771</a>
                            &nbsp;(Hạnh)
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 grid-item">
                        <div className="comp-location">
                          <div className="loc-icon">
                            <i className="las la-map-marker-alt" />
                          </div>
                          <h6>
                            <FormattedMessage id="footer.a9_2" />
                          </h6>
                          <span>
                            <FormattedMessage id="footer.a13" />
                          </span>
                          <p>
                            SĐT/Zalo: <a href="tel:0334374734">0334.374.734</a>
                            &nbsp;(Đức)
                          </p>
                          <p>
                            SĐT/Zalo: <a href="tel:0965103301">0965.103.301</a>
                            &nbsp;(Danh)
                          </p>
                        </div>
                      </div>

                      <div className="col-lg-3 grid-item">
                        <div className="comp-location">
                          <div className="loc-icon">
                            <i className="las la-map-marker-alt" />
                          </div>
                          <h6>
                            <FormattedMessage id="footer.a17" />
                          </h6>
                          <span>
                            <FormattedMessage id="footer.a16" />
                          </span>
                          <p>
                            SĐT/Zalo: <a href="tel:0359515131">0359.515.131</a>
                            &nbsp;(Phước)
                          </p>
                        </div>
                      </div>

                      <div className="col-lg-3 grid-item">
                        <div className="comp-location">
                          <div className="loc-icon">
                            <i className="las la-map-marker-alt" />
                          </div>
                          <h6>
                            <FormattedMessage id="footer.a20" />
                          </h6>
                          <span>
                            <FormattedMessage id="footer.a19" />
                          </span>
                          <p>
                            SĐT/Zalo: <a href="tel:0359515131">0359.515.131</a>
                            &nbsp;(Phước)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="copyright-text">
                    <p>
                      © Owned by {""}
                      <Link to="/">TOP HAI PHUOC - Anovator VN {""}</Link>
                    </p>
                    <div className="view-count text-muted">
                      <i className="fas fa-eye">
                        <span>{formattedViews}</span>
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));
